import { Component, EventEmitter, forwardRef, Input, Output, signal, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'tt-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
  imports: [FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ColorPickerComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorPickerComponent implements ControlValueAccessor {
  protected color = signal('#000000');

  @Input() public showHex = false;

  @Input() public label = '';

  @Input() public set selectedColor(value: string) {
    this.color.set(value);
  }

  public get selectedColor(): string {
    return this.color();
  }

  @Output() public colorChanged = new EventEmitter<string>();

  // ControlValueAccessor implementation
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private onChange: (value: string) => void = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private onTouched: () => void = () => {};
  private disabled = false;

  public writeValue(value: string): void {
    if (value) {
      this.color.set(value);
    }
  }

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  protected onColorChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    const newColor = target.value;
    this.color.set(newColor);
    this.colorChanged.emit(newColor);
    this.onChange(newColor);
    this.onTouched();
  }
}
